import { useSyncExternalStore, useCallback } from 'react'

const STORAGE_KEY = 'rafobase:recent-commands'
const MAX_RECENT = 5

let listeners: Array<() => void> = []
let cachedSnapshot: string[] = []
let cachedRaw: string | null = null

function emitChange() {
  // Invalidate cache
  cachedRaw = null
  for (const listener of listeners) {
    listener()
  }
}

function getSnapshot(): string[] {
  const raw = localStorage.getItem(STORAGE_KEY)
  // Return cached reference if value hasn't changed
  if (raw === cachedRaw) return cachedSnapshot
  cachedRaw = raw
  try {
    cachedSnapshot = raw ? JSON.parse(raw) : []
  } catch {
    cachedSnapshot = []
  }
  return cachedSnapshot
}

const serverSnapshot: string[] = []

function subscribe(listener: () => void) {
  listeners = [...listeners, listener]
  return () => {
    listeners = listeners.filter((l) => l !== listener)
  }
}

export function useRecentCommands() {
  const recentIds = useSyncExternalStore(subscribe, getSnapshot, () => serverSnapshot)

  const addRecent = useCallback((id: string) => {
    const current = getSnapshot()
    const filtered = current.filter((item) => item !== id)
    const updated = [id, ...filtered].slice(0, MAX_RECENT)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
    emitChange()
  }, [])

  return { recentIds, addRecent }
}
